<style scoped>
</style>
<template>
  <div>
    <div class="d-flex justify-content-center" mb=0.5>
      <div pr=1><i class="bi bi-chevron-up time-task-changer" @click="increaseMinutes()"></i></div>
      <div pl=1><i class="bi bi-chevron-up time-task-changer" @click="increaseSeconds()"></i></div>
    </div>
    <div :class="`text-dark-blue timer-text ${valid ? '' : 'invalid'}`">
      {{ formattedMinutes }}:{{ formattedSeconds }}
    </div>
    <div class="d-flex justify-content-center" mt=0.5>
      <div pr=1><i :class="`bi bi-chevron-down time-task-changer ${decreaseMinutesDisabled}`" @click="decreaseMinutes()"></i></div>
      <div pl=1><i :class="`bi bi-chevron-down time-task-changer ${decreaseSecondsDisabled}`" @click="decreaseSeconds()"></i></div>
    </div>
  </div>
</template>
<script>
  export default{
    model:{
      prop: 'initialSeconds',
      event: 'change',
    },
    props: {
      initialSeconds: {
        type: Number,
        default: 0 
      },
      valid: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return {
        seconds: 0,
      }
    },
    computed: {
      formattedMinutes: function(){
        let minutes = Math.trunc(this.seconds/60)
        return minutes.toString().padStart(2, '0');
      },
      formattedSeconds: function(){
        return (this.seconds%60).toString().padStart(2, '0');
      },
      decreaseMinutesDisabled: function(){
        let minutes = Math.trunc(this.seconds/60)
        return minutes==0 ? 'disabled' : '';
      },
      decreaseSecondsDisabled: function(){
        return this.seconds==0 ? 'disabled' : '';
      }
    },
    methods: {
      increaseMinutes: function(){
        this.seconds+=60;
        this.emitChange();
      },
      decreaseMinutes: function(){
        let minutes = Math.trunc(this.seconds/60)
        if(minutes>0){
          this.seconds-=60;
          this.emitChange();
        }
      },
      increaseSeconds: function(){
        this.seconds++;
        this.emitChange();
      },
      decreaseSeconds: function(){
        if(this.seconds>0){
          this.seconds--;
          this.emitChange();
        }
      },
      emitChange: function(){
        this.$emit('change', this.seconds);
      },
    },
    watch: {
      initialSeconds: function(newValue){
        this.seconds = newValue
      }
    },
    beforeMount(){
      this.seconds = this.initialSeconds
    }
  }
</script>
